export default __webpack_public_path__ + "static/media/Ballroll_00281.ddc010af.png";